<script>
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import NotificationCenter from '@components/NotificationCenter';

export default {
  components: {
    NotificationCenter
  },
  data() {
    return {
      user: {
        show_deleted_records: false,
      },
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
  },
  watch: {
    currentUser() {
      this.user = Object.assign({}, this.user, cloneDeep(this.currentUser));
    },
  },
  mounted() {
    this.user = Object.assign({}, this.user, cloneDeep(this.currentUser));
  },
  methods: {
    logout() {
      this.$wait.start('global loading');
      this.$store
        .dispatch('auth/logout', {
          router: this.$router,
        })
        .then(() => {
          this.$wait.end('global loading');
        });
    },
    toggleShowDeletedRecords() {
      this.$nextTick(() => {
        this.$wait.start('global loading');
        this.$http
          .put('admin/set-show-deleted-records/', {
            show_deleted_records: this.user.show_deleted_records,
          })
          .then((response) => {
            this.$store.commit('auth/USER', response.data.user);
            this.$wait.end('global loading');
            window.location.reload();
          })
          .catch(() => this.$wait.end('global loading'));
      });
    },
  },
};
</script>

<template>
  <b-navbar toggleable="md" class="border-bottom" variant="dark" type="dark" :sticky="true">
    <!--<b-navbar-brand :to="{ name: 'home.index' }">HPWebApp</b-navbar-brand>-->
    <b-navbar-brand to="/" class="position-relative">
      <img src="@assets/images/logo.gif" class="d-inline-block align-top" alt="KKS" height="30px" />
      <b-badge :class="$style.adminBadge" variant="danger">admin</b-badge>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-collapse id="nav_collapse" is-nav>
      <b-navbar-nav>
        <template v-if="$store.state.auth.authenticated">
          <b-nav-item active-class="active" :to="{ name: 'reports.index' }">{{ $t('titles.reports') }}</b-nav-item>
          <b-nav-item :to="{ name: 'jobs.index' }">{{ $t('titles.jobs') }}</b-nav-item>
          <b-nav-item :to="{ name: 'jobs.planning.index' }">{{ $t('titles.planning_view') }}</b-nav-item>
          <b-nav-item v-can:doAccounting active-class="active" :to="{ name: 'carTimes.index' }">{{ $t('titles.car_times') }} </b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'drivers.index' }">{{ $t('titles.drivers') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'leaves.index' }">{{ $t('titles.leave_menu') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'cars.index' }">{{ $t('titles.cars') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'quotes.index' }">{{ $t('titles.quotes') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'downloads.index' }">{{ $t('titles.downloads') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'pointOfInterests.index' }">{{ $t('titles.poi') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'news.index' }">{{ $t('titles.news') }}</b-nav-item>
          <b-nav-item-dropdown :text="$t('titles.entities')" right>
            <b-dropdown-item v-can:superAdministrate active-class="active" :to="{ name: 'admins.index' }">{{ $t('titles.admins') }} </b-dropdown-item>
            <b-dropdown-item v-can:doAccounting :to="{ name: 'allowances.index' }">{{ $t('titles.allowances') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'car-owners.index' }">{{ $t('titles.car_owners') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'carTypes.index' }">{{ $t('titles.car_types') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'companies.index' }">{{ $t('titles.companies') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'contacts.index' }">{{ $t('titles.contacts') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'costTypes.index' }">{{ $t('titles.cost_types') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'countries.index' }">{{ $t('titles.countries') }}</b-dropdown-item>
            <b-dropdown-item v-can:superAdministrate :to="{ name: 'downloadCategories.index' }">{{ $t('titles.download_categories') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'locations.index' }">{{ $t('titles.locations') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'serviceProviders.index' }">{{ $t('titles.service_providers') }}</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'vips.index' }">{{ $t('titles.vips') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <template v-if="!$store.state.auth.authenticated">
          <b-nav-item :to="{ name: 'login.index' }">{{ $t('titles.login') }}</b-nav-item>
        </template>
        <template v-else>
          <NotificationCenter />
          <img
            v-if="$store.state.auth.user.avatar"
            class="mb-sm-0 mr-2 rounded-circle d-none d-sm-block"
            height="40"
            :src="$store.state.auth.user.avatar.small"
            alt="Avatar"
          />
          <img v-else class="mb-sm-0 mr-2 rounded-circle d-none d-sm-block" height="40" src="@assets/images/none.png" alt="Avatar" />
          <b-nav-item-dropdown :text="$store.state.auth.user.name" right>
            <b-dropdown-item v-if="$can('superAdministrate')" @click.stop>
              <b-nav-form @click.stop>
                <b-form-checkbox v-model="user.show_deleted_records" name="check-button" switch :value="1" :unchecked-value="0" @change="toggleShowDeletedRecords" @click.stop>
                  <span>{{ $t('fields.show_deleted_records') }}</span>
                </b-form-checkbox>
              </b-nav-form>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'profile.index' }">{{ $t('titles.profile') }}</b-dropdown-item>
            <b-dropdown-item href="#" @click="logout">{{ $t('titles.logout') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style lang="scss" module>
.adminBadge {
  position: absolute;
  right: 0;
  bottom: -4px;
  font-size: 8px;
}
</style>
